import { Settings } from "@/components/ui/SettingsSection";
import { DeleteMeButton } from "./DeleteMeButton";

export function DeleteMeSection() {
  return (
    <Settings.Section
      title="Delete account"
      className="bg-brand-gray-50 dark:bg-brand-error/15"
    >
      <Settings.Item
        title="Delete your Numerous account"
        description="This action cannot be undone."
      >
        <DeleteMeButton />
      </Settings.Item>
    </Settings.Section>
  );
}
